import React from 'react';
import './Header.css';

function Header({ account, isConnecting, connectWallet, disconnectWallet, onTourStart, onTelegramOpen, showTelegram }) {
  const formatAddress = (addr) => addr ? `${addr.slice(0, 6)}...${addr.slice(-4)}` : '';

  return (
    <header className="header">
      <div className="header-content">
        <div className="logo-container">
          <img src="/logo.png" alt="AlphaMeta" className="logo-image" />
          <div className="logo-text">
            <span className="logo-title">ALPHA</span>
            <span className="logo-subtitle">META</span>
          </div>
        </div>

        <div className="header-right">
          {showTelegram && onTelegramOpen && (
            <button className="telegram-btn" onClick={onTelegramOpen} title="Telegram Notifications">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z"/>
              </svg>
            </button>
          )}
          {onTourStart && (
            <button className="tour-btn" onClick={onTourStart}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <path d="M12 16v-4M12 8h.01" />
              </svg>
            </button>
          )}

          {!account ? (
            <button className="connect-btn" onClick={connectWallet} disabled={isConnecting}>
              {isConnecting ? (
                <><span className="btn-spinner" />Connecting...</>
              ) : (
                <>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4" />
                    <path d="M3 5v14a2 2 0 0 0 2 2h16v-5" />
                    <path d="M18 12a2 2 0 0 0 0 4h4v-4h-4z" />
                  </svg>
                  Connect
                </>
              )}
            </button>
          ) : (
            <div className="wallet-info">
              <div className="wallet-status">
                <span className="status-dot" />
                <span className="wallet-address">{formatAddress(account)}</span>
              </div>
              <button className="disconnect-btn" onClick={disconnectWallet}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                  <polyline points="16 17 21 12 16 7" />
                  <line x1="21" y1="12" x2="9" y2="12" />
                </svg>
              </button>
            </div>
          )}
        </div>
      </div>
      <div className="header-glow" />
    </header>
  );
}

export default Header;
